import blank from "./blank";
import eyepatch from "./eyepatch";
import kurt from "./kurt";
import prescription01 from "./prescription-01";
import prescription02 from "./prescription-02";
import round from "./round";
import sunglasses from "./sunglasses";
import wayfarers from "./wayfarers";

export default {
	blank,
	eyepatch,
	kurt,
	prescription01,
	prescription02,
	round,
	sunglasses,
	wayfarers,
};



// WEBPACK FOOTER //
// ./src/accessories/index.js